var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class ZeeVee {
    constructor(socket, log) {
        this.socket = socket;
        this.responseCounter = 0;
        this.channels = {};
        this.presets = {};
        this.v2Firmware = false; // Command responses changed with v3
        this.timeouts = new Timeouts();
        this.asyncHandlers = [
            {
                name: 'audioFollowsVideo',
                regExp: /join videoSource (.+) (.+)/i,
                callback: (match) => {
                    const resp = {
                        status: 'Success',
                        text: [],
                        errors: [],
                        warnings: [],
                        command: `${match[0]}`,
                    };
                    this.socket.send(`${this.cmdPrefix()}${JSON.stringify(resp)}`);
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /show server info/i,
                callback: (match) => {
                    const timeNow = new Date().toLocaleString();
                    this.systemStatus.time.time = timeNow;
                    this.systemStatus.gen.uptime = this.getUptime();
                    const resp = {
                        status: 'Success',
                        text: this.systemStatus,
                        errors: [],
                        warnings: [],
                        command: `${match[0]}`,
                    };
                    this.socket.send(`${this.cmdPrefix()}${JSON.stringify(resp)}`);
                },
            },
            {
                name: 'getDeviceList',
                regExp: /show device status (.+)/i,
                callback: (match) => {
                    const uptime = this.getUptime();
                    let resp = {};
                    if (match[1] === 'all') {
                        const devices = Object.values(this.channels);
                        devices.forEach(dev => {
                            dev.gen.uptime = uptime;
                        });
                        resp = {
                            status: 'Success',
                            text: devices,
                            errors: [],
                            warrnings: [],
                            command: `${match[0]}`,
                            lastChangeIdMax: '23',
                        };
                    }
                    else if (this.channels.hasOwnProperty(match[1])) {
                        const device = this.channels[match[1]];
                        device.gen.uptime = uptime;
                        resp = {
                            status: 'Success',
                            text: [device],
                            errors: [],
                            warrnings: [],
                            command: `${match[0]}`,
                            lastChangeIdMax: '23',
                        };
                    }
                    else {
                        resp = {
                            status: 'Success',
                            text: [],
                            errors: ['Error:(7) Unknown device or mac address or device name'],
                            warrnings: [],
                            command: `${match[0]}`,
                        };
                    }
                    this.socket.send(`${this.cmdPrefix()}${JSON.stringify(resp)}`);
                },
            },
            {
                name: 'getPreset',
                regExp: /show preset (.+) commandBlob/i,
                callback: (match) => {
                    if (match[1] === 'all') {
                        const resp = {
                            status: 'Success',
                            text: Object.values(this.presets),
                            errors: [],
                            warnings: [],
                            command: `${match[0]}`,
                            lastChangeIdMax: 1,
                        };
                        this.socket.send(`${this.cmdPrefix()}${JSON.stringify(resp)}`);
                    }
                    else if (this.presets.hasOwnProperty(match[1])) {
                        const resp = {
                            status: 'Success',
                            text: [this.presets[match[1]]],
                            errors: [],
                            warnings: [],
                            command: `${match[0]}`,
                            lastChangeIdMax: 1,
                        };
                        this.socket.send(`${this.cmdPrefix()}${JSON.stringify(resp)}`);
                    }
                    else {
                        this.socket.send(`${this.cmdPrefix()}error message... `);
                    }
                },
            },
            {
                name: 'runPreset',
                regExp: /run preset (.+)/i,
                callback: (match) => {
                    if (this.presets.hasOwnProperty(match[1])) {
                        const resp = {
                            status: 'Success',
                            text: [],
                            errors: [],
                            warnings: [],
                            command: `${match[0]}`,
                            lastChangeIdMax: 1,
                        };
                        this.socket.send(`${this.cmdPrefix()}${JSON.stringify(resp)}`);
                    }
                    else {
                        this.socket.send(`${this.cmdPrefix()}Error:(41) Preset ${match[1]} does not exist`);
                    }
                },
            },
            {
                name: 'terminalOutput',
                regExp: /set terminal output json echo no prompt no/i,
                callback: (match) => {
                    const resp = {
                        status: 'Success',
                        text: [],
                        errors: [],
                        warnings: [],
                        command: `${match[0]}`,
                        lastChangeIdMax: 1,
                    };
                    this.socket.send(`${this.cmdPrefix()}${JSON.stringify(resp)}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /join (.+) (.+) fastSwitched/i,
                callback: (match) => {
                    var _a;
                    const inputMac = match[1]; // the encoder
                    const outputMac = match[2]; // the decoder
                    const resp = {
                        status: 'Success',
                        text: [],
                        errors: [],
                        warnings: [],
                        command: `${match[0]}`,
                    };
                    // update device status with the new connected encoder/input
                    if (this.channels.hasOwnProperty(outputMac)) {
                        const connectedEncoderName = inputMac !== 'none' ? (_a = this.channels[inputMac].gen.name) !== null && _a !== void 0 ? _a : 'none' : 'none';
                        this.channels[outputMac]['connectedEncoder'] = {
                            mac: inputMac,
                            name: connectedEncoderName,
                        };
                        this.channels[outputMac]['connectedEncoderHdmiAudio'] = {
                            mac: inputMac,
                            name: connectedEncoderName,
                            receivingAudioFromEncoder: connectedEncoderName === 'none' ? 'no' : 'yes',
                        };
                    }
                    else {
                        resp.errors = ['Error:(7) Unknown device or mac address or device name'];
                    }
                    this.socket.send(`${this.cmdPrefix()}${JSON.stringify(resp)}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    const resp = {
                        status: 'Success',
                        text: [],
                        errors: [
                            `Error:(13) Bad syntax in input line \"${match[0]}\" -- token \"${match[0]}\" is invalid`,
                        ],
                        warnings: [],
                        command: `${match[0]}`,
                    };
                    this.socket.send(`${this.cmdPrefix()}${JSON.stringify(resp)}`);
                },
            },
        ];
        this.sendTerminator = '\r\n';
        this.startTime = Date.now();
        const numberVideoInputs = 8;
        const numberVideoOutputs = 16;
        const numberPresets = 4;
        this.createDecoders(numberVideoOutputs);
        this.createEncoders(numberVideoInputs);
        this.createPresets(numberPresets);
        this.systemStatus = {
            gen: {
                ip: '192.168.1.22',
                hostname: 'zyper.local',
                version: '2.5.1.37752',
                previousVersion: '2.3.1.37395',
                macAddress: '1c:1b:0d:82:fd:fd',
                serialNumber: 'ZZM6H500008B',
                uptime: '',
                freeMem: '7.11GB',
                bootCount: '68',
                runningInVm: 'false',
            },
            ipActive: {
                ipServerAddr: '192.168.1.22',
                ipManagementAddr: 'NA',
                gatewayAddr: 'none',
                dnsAddr: 'none',
            },
            time: { time: '', timezone: 'America/New_York' },
            license: {
                productID: '031B021C-040D-0582-FD06-FD0700080009',
                license: 'none',
                Zyper4KLimit: '24',
                Zyper4KDevices: '0',
                allDevices: `${numberVideoInputs + numberVideoOutputs}`,
                allDevicesUp: `${numberVideoInputs + numberVideoOutputs}`,
                Zyper4KDevicesExceeded: '0',
            },
            deviceUpdates: { active: '0' },
            activeDeviceVersions: {
                'num_2.0.4.18': `${numberVideoInputs + numberVideoOutputs}`,
            },
        };
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            yield this.timeouts.delay(1000);
            this.socket.sendRaw(`Zyper$ `); // command line prompt when no password is enabled
        });
    }
    cmdPrefix() {
        this.responseCounter++;
        return this.v2Firmware ? `[ ${this.responseCounter.toString().padStart(4, '0')}]` : '';
    }
    createDecoders(num) {
        for (let i = 1; i <= num; i++) {
            const macAddress = `de:c0:de:00:00:${i.toString(16).padStart(2, '0')}`;
            const chanName = `Decoder_${i.toString().padStart(3, '0')}`;
            const uptime = this.getUptime();
            const endPoint = {
                gen: {
                    mac: macAddress,
                    model: 'ZyperUHD',
                    type: 'decoder',
                    virtualType: 'none',
                    name: `${chanName}`,
                    state: 'Up',
                    uptime: uptime,
                    lastChangeId: '23',
                    productCode: 'ZUHDDEC',
                    productDescription: 'Copper Decoder - HDMI 1.4',
                    pid: '0x0',
                },
                firmwareUpdate: { status: 'idle', loadingFile: 'none', percentComplete: '0' },
                hdmiOutput: {
                    videoTimingSource: 'displayEdidMaxResolution',
                    cableConnected: 'connected',
                    hdcp: 'active',
                    hdcpVersion: '1.4',
                    'hdmi2.0': 'no',
                    horizontalSize: '1920',
                    verticalSize: '1080',
                    fps: '60.000',
                    interlaced: 'no',
                    hTot: '2200',
                    hBlank: '280',
                    hFront: '88',
                    hSync: '44',
                    hSyncPol: 'positive',
                    vTot: '1125',
                    vBlank: '45',
                    vFront: '4',
                    vSync: '5',
                    vSyncPol: 'positive',
                    pixelClock: '148.500',
                    colorEncoding: 'RGB',
                    colorDepth: '8',
                    colorSpace: 'BT601',
                    colorQuantRange: 'default',
                    timingStandard: 'CEA-861-F VIC-16',
                    streamDatarate: '400Mbps',
                },
                edid: {
                    sourceType: 'decoder',
                    edidStatus: 'valid',
                    edidMonitorName: 'LG TV',
                    firstDescriptorPreferredResolution: 'yes',
                    maxFps: '62.00',
                    maxPixelClockMhz: '160.00',
                    maxDeepColorPixelClockMhz: '150.00',
                    rgbColorDepth: '8',
                    yuv420ColorDepth: '0',
                    only420: 'none',
                    also420: 'none',
                    yuvQuantRange: 'default',
                    rgbQuantRange: 'default',
                    audio: {
                        PCM: {
                            channels: '2',
                            sampleRates: '192Khz-96Khz-48Khz-44.1Khz-32Khz',
                            sampleBits: '16-20',
                        },
                    },
                    preferredResolution: {
                        pixelClockMhz: '148.50',
                        sizeX: '1920',
                        sizeY: '1080',
                        fps: '60.00',
                    },
                    maxResolution: {
                        pixelClockMhz: '148.50',
                        sizeX: '1920',
                        sizeY: '1080',
                        fps: '60.00',
                    },
                },
                // Initialize all decoders to encoder 1
                connectedEncoder: {
                    mac: 'ee:c0:de:00:00:01',
                    name: 'Encoder_001',
                    receivingVideoFromEncoder: 'yes',
                },
                connectedEncoderAnalogAudio: {
                    mac: 'none',
                    name: 'none',
                    receivingAudioFromEncoder: 'no',
                },
                connectedEncoderHdmiAudio: {
                    mac: 'ee:c0:de:00:00:01',
                    name: 'Encoder_001',
                    receivingAudioFromEncoder: 'yes',
                },
                activeVideoWall: { name: 'none' },
                usb: { linkActive: 'false', failed: 'false' },
            };
            this.channels[macAddress] = endPoint;
        }
    }
    createEncoders(num) {
        for (let i = 1; i <= num; i++) {
            const macAddress = `ee:c0:de:00:00:${i.toString(16).padStart(2, '0')}`;
            const chanName = `Encoder_${i.toString().padStart(3, '0')}`;
            const uptime = this.getUptime();
            const endPoint = {
                gen: {
                    mac: `${macAddress}`,
                    model: 'ZyperUHD',
                    type: 'encoder',
                    virtualType: 'none',
                    name: `${chanName}`,
                    state: 'Up',
                    uptime: uptime,
                    lastChangeId: '19',
                    productCode: 'ZUHDENC',
                    productDescription: 'Copper Encoder - HDMI 1.4',
                    pid: '0x0',
                },
                firmwareUpdate: { status: 'idle', loadingFile: 'none', percentComplete: '0' },
                hdmiInput: {
                    cableConnected: 'connected',
                    hdcp: 'inactive',
                    hdcpVersion: 'none',
                    'hdmi2.0': 'no',
                    horizontalSize: '1280',
                    verticalSize: '720',
                    fps: '50.000',
                    interlaced: 'no',
                    hTot: '1980',
                    hBlank: '700',
                    hFront: '440',
                    hSync: '40',
                    hSyncPol: 'positive',
                    vTot: '750',
                    vBlank: '30',
                    vFront: '5',
                    vSync: '5',
                    vSyncPol: 'positive',
                    pixelClock: '74.250',
                    colorEncoding: 'RGB',
                    colorDepth: '8',
                    colorSpace: 'BT709',
                    colorQuantRange: 'default',
                    timingStandard: 'CEA-861-F VIC-19',
                },
                edid: {
                    sourceType: 'encoder',
                    edidStatus: 'valid',
                    edidMonitorName: 'zHd60',
                    firstDescriptorPreferredResolution: 'yes',
                    maxFps: '61.00',
                    maxPixelClockMhz: '150.00',
                    maxDeepColorPixelClockMhz: '0.00',
                    rgbColorDepth: '8',
                    yuv420ColorDepth: '0',
                    only420: 'none',
                    also420: 'none',
                    yuvQuantRange: 'default',
                    rgbQuantRange: 'fromAviInfoFrame',
                    audio: {
                        PCM: {
                            channels: '8',
                            sampleRates: '48Khz-44.1Khz-32Khz',
                            sampleBits: '16-20',
                        },
                    },
                    preferredResolution: {
                        pixelClockMhz: '148.50',
                        sizeX: '1920',
                        sizeY: '1080',
                        fps: '60.00',
                    },
                    maxResolution: {
                        pixelClockMhz: '148.50',
                        sizeX: '1920',
                        sizeY: '1080',
                        fps: '60.00',
                    },
                },
                videoStream: {
                    inputFps: '50.00',
                    inputDatarate: '1782Mbps',
                    compressionFactor: '0.22',
                    streamFps: '1.00',
                    streamDatarate: '400Mbps',
                },
                previewStream: { status: 'up', recvData: 'true' },
            };
            this.channels[macAddress] = endPoint;
        }
    }
    createPresets(num) {
        for (let i = 1; i <= num; i++) {
            const presetName = `Preset_${i}`;
            const preset = {
                gen: { name: presetName },
                cmdBlob: { cmdBlob: 'join none Decoder_001' },
            };
            this.presets[presetName] = preset;
        }
    }
    getUptime() {
        const uptime = Date.now() - this.startTime;
        const days = Math.floor(uptime / 86400000);
        let hours = Math.floor(uptime / 3600000);
        if (hours === 24)
            hours = 0;
        const minutes = Math.floor((uptime % 3600000) / 60000);
        const seconds = Math.floor((uptime % 60000) / 1000);
        return `${days}d:${hours}h:${minutes}m:${seconds}s`;
    }
}
ZeeVee.emulatorType = 'socketEmulator';
ZeeVee.key = '-NCabdQuIWeZXxONZEJc';
